<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="graph" style="font-size: 14px">
    <div>
      <label class="label-head">Logger</label>
    </div>
    <div class="container-fluid">
      <v-row class="style-border" style="border: 1px solid #666666;">
        <v-col class="overflow-logger">
          {{ loggers_selected }}
        </v-col>
        <v-col align="right">
          <v-btn class="btn-div" color="#8A8A8F" dark @click="dialog_logger = true">
            ...
          </v-btn>
          <v-dialog v-model="dialog_logger" width="500">
            <v-card>
              <v-card-title class="headline grey lighten-2" primary-title>
                เพิ่มรายการมาตรวัด
              </v-card-title>

              <v-card-text>
                <v-row v-if="Object.keys(districts).length > 1">
                  <v-col cols="2">
                    <label>เขต</label>
                  </v-col>
                  <v-col cols="10">
                    <b-form-select @change="[branch_id = null, logger_id = null]" :options="districts" v-model="district_id">
                      <template slot="first">
                        <option :value="null" selected disabled>-เลือกเขต-</option>
                      </template>
                    </b-form-select>
                  </v-col>
                </v-row>
                <v-row v-if="Object.keys(branches).length > 1">
                  <v-col cols="2">
                    <label>สาขา</label>
                  </v-col>
                  <v-col cols="10">
                    <b-form-select @change="logger_id = null" v-model="branch_id">
                      <option v-for="(item, index) in branches"
                              :key="index"
                              :value="item.value"
                              v-if="parseInt(item.district_id) === parseInt(district_id)">
                        {{ item.text }}
                      </option>
                      <template slot="first">
                        <option :value="null" selected disabled>-เลือกสาขา-</option>
                      </template>
                    </b-form-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="2">
                    <label>logger</label>
                  </v-col>
                  <v-col cols="10">
                    <b-form-select v-model="logger_id">
                      <option v-for="(item, index) in loggers"
                              :key="index"
                              :value="item.value"
                              v-if="parseInt(item.branch_id) === parseInt(branch_id)">
                        {{ item.text }}
                      </option>
                      <template slot="first">
                        <option :value="null" disabled selected>-เลือกมาตรวัด-</option>
                      </template>
                    </b-form-select>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="UpdateLogger">
                  ยืนยัน
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </div>
    <template v-if="loggers_selected">
      <div>
        <div>
          <label class="label-head">ข้อมูล</label>
        </div>
      </div>
      <div class="container-fluid">
        <v-row class="style-border" style="border: 1px solid #666666;">
          <v-col class="overflow-logger">
            {{ parameters_display.toString() }}
          </v-col>
          <v-col align="right">
            <v-btn class="btn-div" color="#8A8A8F" dark @click="dialog_parameter = true">
              ...
            </v-btn>
            <v-dialog v-model="dialog_parameter" width="500">
              <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                  เพิ่มข้อมูล
                </v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col>
                      <v-checkbox v-for="item in parameters.slice(0,(parameters.length/2)+1)"
                                  v-model="parameters_selected" :value="item.code"
                                  :label="item.name" style="margin: 0%" color="success"/>
                    </v-col>
                    <v-col>
                      <v-checkbox v-for="item in parameters.slice((parameters.length/2)+1)"
                                  v-model="parameters_selected" :value="item.code"
                                  :label="item.name" style="margin: 0%" color="success"/>
                    </v-col>
                  </v-row>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="UpdateParameter">
                    ยืนยัน
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
      </div>

      <template v-if="parameters_display.length > 0">
        <div class="container-fluid" id="alert_container">
          <v-row>
            <v-col>
              <v-switch v-model="show_predict" @change="UpdateValue" inset :label="`เส้นทำนาย`" dark color="info"/>
            </v-col>
            <v-col>
              <v-switch v-model="show_alert" @change="UpdateValue" inset :label="`เส้นแจ้งเตือน`" dark color="info"/>
            </v-col>
          </v-row>
        </div>
        <div class="container-fluid" id="frequency_container">
          <v-row>
            <v-col style="padding: 10px 5px 0 0" class="d-flex" cols="6">
              <v-select
                @change="UpdateValue"
                v-model="freq"
                :items="period"
                label="ความถี่"
                outlined
                dark
              />
            </v-col>
            <v-col style="padding: 10px 5px 0 0" class="d-flex" cols="6">
              <v-select
                @change="UpdateTime"
                v-model="select_time"
                :items="times"
                label="เวลาย้อนหลัง"
                outlined
                dark
                v-resize="function (){ return false}"
              />
            </v-col>
          </v-row>
          <v-row>
            <label class="label-head">กราฟ</label>
          </v-row>
          <v-row>
            <canvas height="300" id="chart"/>
          </v-row>
          <v-row v-if="items_summary.meta">
            <label class="label-head">ข้อมูลสรุป</label>
          </v-row>
          <v-row style="padding-top: 5px" v-if="items_summary.meta">
            <div class="table-responsive">
              <table style="width: 100%; margin-top: 5%">
                <thead style="background-color: #262628;" align="center">
                <tr>
                  <th v-for="item in items_summary.meta.header"
                      :colspan="item.colspan"
                      :rowspan="item.rowspan"
                      style="background-color: #262628;">
                    <div>{{ item.label }}</div>
                  </th>
                </tr>
                <tr v-if="items_summary.meta.header2.length > 0">
                  <th
                    v-for="item in items_summary.meta.header2"
                    :colspan="item.colspan"
                    :rowspan="item.rowspan">
                    {{ item }}
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item,key) in items_summary.dataset">
                  <td>
                    <div>{{item.label }}</div>
                  </td>
                  <td v-for="value in item.value">{{value }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </v-row>
          <v-row v-if="items_summary.meta" style="padding-top: 5px">
            <b-button class="btn-time-series" target="_blank"
                      :to="link_time_series">
              ดูข้อมูลล่าสุด
            </b-button>
          </v-row>
        </div>
      </template>
    </template>

  </div>
</template>

<script>
  import Api from '../providers/Api'
  import Chart from 'chart.js'

  export default {
    data () {
      return {
        dialog_logger: false,
        dialog_parameter: false,
        checkbox: false,
        show_predict: false,
        show_alert: true,
        freq: 5,
        dataset: [],
        items_summary: [],
        districts: [],
        branches: [],
        loggers: [],
        district_id: null,
        branch_id: null,
        logger_id: null,
        loggers_selected: null,
        select_time: 2,
        times: [
          { value: 0, text: 'เลือกเวลา', selected: true, disabled: true },
          { value: 2, text: '2 ชั่วโมง' },
          { value: 6, text: '6 ชั่วโมง' },
          { value: 12, text: '12 ชั่วโมง' },
          { value: 24, text: '24 ชั่วโมง' },
          { value: 168, text: '7 วัน' }
        ],
        period: [
          { value: 0, text: 'เลือกความถี่', selected: true, disabled: true },
          { value: 1, text: '1 นาที' },       //FREQUENCY_1m
          { value: 5, text: '5 นาที' },       //FREQUENCY_5m
          { value: 15, text: '15 นาที' },     //FREQUENCY_15
          { value: 30, text: '30 นาที' },     //FREQUENCY_30
          { value: 60, text: '1 ชั่วโมง' },    //FREQUENCY_1H
          { value: 1440, text: '1 วัน' },     //FREQUENCY_1D
          { value: 10080, text: '1 สัปดาห์' }, //FREQUENCY_1W
          { value: 43830, text: '1 เดือน' },  //FREQUENCY_1M
          { value: 525960, text: '1 ปี' }     //FREQUENCY_1Y
        ],
        parameters_mnf: [
          { code: 'flow(MNF)', name: 'Flow(MNF)' },
          { code: 'pressure(MNF)', name: 'Pressure(MNF)' },
          { code: 'target(MNF)', name: 'Target(MNF)' }
        ],
        lang: {
          days: ['อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.'],
          months: ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'],
          monthNames: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม']
        },
        parameters: [],
        branchId: 1,
        parameters_selected: ['flow', 'pressure'],
        parameters_display: [],
        date_range: [
          moment().subtract(2, 'hours').format("YYYY-MM-DD HH:mm:ss"),
          moment().format("YYYY-MM-DD HH:mm:ss")
        ],
        menu_datepicker: false,
        chart_items: [],
      }
    },
    computed: {
      link_time_series() {
        return {
          name :`time_series`,
          query: {
            date_range_from: this.date_range[0],
            date_range_to: this.date_range[1],
            freq: this.freq,
            show_data_predict: this.show_predict,
            show_line_alert: this.show_alert,
            logger_id: [this.logger_id],
            fields: this.parameters_selected,
          }
        }
      },
    },
    mounted () {
      let parameter = this.$route.query.parameter || null
      if (parameter) {
        this.parameters_selected = [parameter]
      }
      setTimeout(() => {
        this.UpdateParameter()
      }, 1000)
    },
    methods: {
      UpdateValue () {
        if(this.logger_id){
          this.getLineGraph()
          this.getSummarize()
        }
      },
      getLineGraph: function () {
        this.items = []
        this.post('/api/analysis/graph', {
          date_range_from: this.date_range[0],
          date_range_to: this.date_range[1],
          freq: this.freq,
          show_data_predict: this.show_predict,
          show_line_alert: this.show_alert,
          loggers: [this.logger_id],
          fields: this.parameters_selected,
          response_type: 'chart_js'

        }).then(({ data }) => {
          if (data.success) {
            this.chart_items = data.data.chart
            this.createChart(this.chart_items)
          }
        })
      },
      getSummarize () {
        this.post(`/api/analysis/normal/get_summarize`, {
          date_range_from: this.date_range[0],
          date_range_to: this.date_range[1],
          freq: this.freq,
          show_data_predict: this.show_predict,
          show_line_alert: this.show_alert,
          loggers: [this.logger_id],
          fields: this.parameters_selected,
        }).then(res => {
          this.items_summary = res && res.data
        })
      },
      isEmpty (e) {
        switch (e) {
          case '':
          case 0:
          case '0':
          case null:
          case false:
          case typeof this === 'undefined':
            return true
          default:
            return false
        }
      },
      formatDate (d) {
        let date = moment(d)
        if (date) {
          return date.add(543, 'y').format('DD-MM-YYYY')
        } else {
          return ''
        }
      },
      filteredBranch () {
        return this.branches.filter(item => item.district_id === district_id)
      },
      UpdateTime () {
        this.date_range[0] = moment().subtract(this.select_time, 'hours').format("YYYY-MM-DD HH:mm:ss"),
          this.date_range[1] = moment().format("YYYY-MM-DD HH:mm:ss")
        this.UpdateValue()
      },
      UpdateLogger () {
        if (this.logger_id) {
          this.loggers_selected = _.find(this.loggers, ['value', this.logger_id]).text
          this.dialog_logger = false
          this.UpdateValue()
        }
      },
      UpdateParameter () {
        this.parameters_display = []
        this.dialog_parameter = false
        this.parameters.forEach((item, key) => {
          this.parameters_selected.forEach((info, index) => {
            if (item.code === info) {
              this.parameters_display.push(item.name)
            }
          })
        })
        this.UpdateValue()
      },
      createChart (data) {
        if (this.chart) {
          this.chart.destroy()
        }
        Chart.defaults.global.defaultFontColor = '#FFFFFF'
        var ctx = document.getElementById('chart').getContext('2d')
        this.chart = new Chart(ctx, {
          type: 'scatter',
          data: {
            labels: data.data.labels,
            datasets: data.data.datasets
          },
          options: data.options
        })
      },
    },
    created () {
      this.get('/api/districts/lov', {}, true, true).then(({ data }) => {
        if (data.success) {
          this.districts = data.data
        }
      })
      this.get('/api/branches/lov', {}, true, true).then(({ data }) => {
        if (data.success) {
          this.branches = data.data
        }
      })
      this.get('/api/loggers/lov', {}, true, true).then(({ data }) => {
        if (data.success) {
          this.loggers = data.data
          this.logger_id = parseInt(this.$route.query.logger_id) || null
          for (let i in this.loggers) {
            if (this.logger_id === this.loggers[i].value) {
              this.branch_id = this.loggers[i].branch_id
              this.district_id = this.loggers[i].district_id
              this.UpdateLogger()
              break
            }
          }
        }
      })
      this.get('/api/parameters/', {}, true, true).then(({ data }) => {
        let parameter_list = data.data
        parameter_list.forEach((item) => {
          if (item.agg_type !== 0)
            this.parameters.push(item)
        })
        this.parameters_mnf.forEach((item) => {
          this.parameters.push(item)
        })
      })
      this.district_id = this.$store.state.district_id
      this.branch_id = this.$store.state.branch_id
    },
    mixins: [
      Api,
    ],
  }
</script>
<style>
  #frequency_container div.v-input__slot {
    min-height: 20px;
  }

  #frequency_container .v-input {
    font-size: 14px;
  }

  #frequency_container .v-select__selections {
    padding: 0;
  }

  #frequency_container .v-input__append-inner {
    margin-top: 4px;
  }

  #frequency_container .v-select__selection--comma {
    margin: 0;
  }

  #alert_container .v-messages {
    min-height: unset;
  }
</style>
<style scoped>
  .graph {
    padding: 10px;
  }

  .style-border {
    border: 1px solid #666666;
  }

  .theme--light.v-expansion-panels .v-expansion-panel {
    background-color: #262628 !important;
    color: #ffffff !important;
  }

  .v-expansion-panel-content {
    background-color: #111113;
  }

  .theme--light.v-expansion-panels .v-expansion-panel-header .v-expansion-panel-header__icon .v-icon {
    color: #fff !important;
  }

  table, th, td {
    border: 1px solid #666666;
  }

  .overflow-logger {
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 210px;
    overflow: hidden;
  }

  .label-head {
    font-style: normal;
    font-weight: normal;
    font-size: 11px;
    line-height: 11px;
    margin: 0;
  }

  .col {
    padding: 4px 4px 4px 12px;
  }

  .btn-div {
    height: 21px !important;
    min-width: 30px !important;
  }
  .btn-time-series {
    color: white;
  }
</style>

